import React, { Component } from 'react';
import { verifyUserEmailChange,getUrlParameter } from '../../lib/api';

class EmailVerify extends Component {
  state ={
    token:"",
    title:"Please wait ..."
  }
  async componentDidMount(){
    try {
      this.setState({loading:true});
      let token = getUrlParameter('token');
      if(token){
        let response = await verifyUserEmailChange(token);
        if(response.success){
          this.setState({success:true,icon:"success",loading:false,title:"Your email address has been successfully verified."});
        }else {
          this.setState({success:true,icon:"failure",loading:false,title:"Email Verification Failed"});
        }
      }
    } catch (error) {
      this.setState({success:false,icon:"failure",loading:false,title:"Email Verification Failed"});
    }
  }
  render() {
    return (
      <div>
        <div className="box">
          <div className="center">
            {
              this.state.loading &&
              <div >
                {this.state.title}
              </div>
            }
            {
              !this.state.loading && 
              <div>
                <img className="image" src={`/images/${this.state.icon}.png`} alt="image"/>
                <h2 className="sentence">{this.state.title} </h2>
              </div>
            }
            
            
          </div>
        </div>
        <style jsx scoped>{`
          .image{
            width: 80px;
            display:block;
            margin:0 auto;
            margin-top:20px;
            margin-bottom:20px;
          }
          .center{
            text-align:center;
            padding:20px;
          }
          .sentence{
            font-size: 25px;
          }
          .box{
            max-width: 707px;
            margin: 50px auto;
            height: 220px;
            border-radius: 20px;
            box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.03);
            border: solid 0.3px #c1c1c1;
            background-color: #ffffff;
          }
        `}</style>
      </div>
    );
  }
}

export default EmailVerify;